<template>
  <div class="app">
    <LoadingAnimation v-if="isLoading" />
    <template v-else>
      <Header />
      <main class="main-content">
        <router-view v-slot="{ Component }">
          <transition name="fade" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </main>
      <Footer />
    </template>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import LoadingAnimation from '@/components/LoadingAnimation.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    LoadingAnimation
  },
  data() {
    return {
      isLoading: true
    }
  },
  mounted() {
    // 模拟加载时间，实际应用中可以根据资源加载情况决定
    setTimeout(() => {
      this.isLoading = false
    }, 2000)
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --primary-color: #4a6cf7;
  --primary-dark: #3151d3;
  --primary-light: #6a8bff;
  --primary-gradient: linear-gradient(to right, #4a6cf7, #6a8bff);
  --secondary-color: #a777e3;
  --text-color: #333;
  --text-light: #666;
  --background-light: #f8f9fa;
  --white: #ffffff;
  --shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  --border-radius: 8px;
  --box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
}

body {
  font-family: 'Inter', sans-serif;
  color: var(--text-color);
  line-height: 1.5;
  overflow-x: hidden;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  flex: 1;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 确保页面内容不会被固定头部遮挡 */
main {
  padding-top: 80px; /* 根据头部高度调整 */
}

/* 移动端调整 */
@media (max-width: 768px) {
  main {
    padding-top: 60px; /* 移动端头部高度较小 */
  }
}

button {
  cursor: pointer;
  border: none;
  border-radius: var(--border-radius);
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-primary {
  background: var(--primary-gradient);
  color: white;
  box-shadow: 0 4px 10px rgba(110, 142, 251, 0.3);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 15px rgba(110, 142, 251, 0.4);
  }
}

.btn-secondary {
  background-color: transparent;
  border: 2px solid var(--primary-color);
  color: var(--primary-color);
  
  &:hover {
    background-color: rgba(110, 142, 251, 0.1);
  }
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  background: var(--primary-gradient);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
}

.section-subtitle {
  font-size: 1.2rem;
  color: var(--text-light);
  margin-bottom: 3rem;
  max-width: 700px;
}

.card {
  background: var(--white);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  }
}

/* 页面过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 添加应用名称的全局样式 */
.app-name {
  font-family: 'Inter', sans-serif;
  font-weight: 800;
  background: var(--primary-gradient);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
}

/* 添加全局样式修复溢出问题 */
html, body {
  overflow-x: hidden;
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
}
</style>
